import { config } from '@/shared/config/env';

export const validateCriticalConfig = (): Array<string> => {
  const missingKeys: Array<string> = [];

  // Check API
  if (!config.api.baseUrl) missingKeys.push('VITE_API_BASE_URL');
  for (const [name, value] of [
    ['CLIENT_PORTAL_URL', config.app.clientPortalUrl],
    ['FRONTEND_URL', config.app.advisorUrl],
  ]) {
    if (!value) continue;
    try {
      const url = new URL(value);
      const local =
        url.hostname === 'localhost' || url.hostname.endsWith('.localhost');
      if (
        (url.protocol !== 'https:' && !(url.protocol === 'http:' && local)) ||
        url.username ||
        url.password ||
        url.search ||
        url.hash ||
        url.pathname !== '/'
      )
        missingKeys.push(name);
    } catch {
      missingKeys.push(name);
    }
  }
  if (config.app.clientPortalUrl && !config.app.advisorUrl)
    missingKeys.push('FRONTEND_URL');
  if (config.app.clientPortalUrl && config.app.advisorUrl) {
    try {
      if (
        new URL(config.app.clientPortalUrl).origin ===
        new URL(config.app.advisorUrl).origin
      )
        missingKeys.push('CLIENT_PORTAL_URL');
    } catch {
      /* named above */
    }
  }

  return missingKeys;
};
